import { EnumType } from 'json-to-graphql-query';
import { distanceFieldName } from '@/helpers/search-client/orderByNames';
import typeMapper from '@/helpers/search-client/typeMapper';

const getSortAttributes = (state, sortParams, unit) => {
  if (!sortParams || !sortParams.length) return [];

  return sortParams
    .map((item) => {
      switch (item.fieldName) {
        case distanceFieldName:
          return {
            fieldName: new EnumType('distance'),
            direction: new EnumType(item.direction),
            distanceDetails: {
              unit: new EnumType(unit),
              coordinates: {
                lat: Number(state.coordinates.lat),
                lon: Number(state.coordinates.lon),
              },
            },
          };
        default:
          return {
            fieldName: new EnumType(item.fieldName),
            direction: new EnumType(item.direction),
          };
      }
    })
    .filter(String);
};

export default {
  setSortParams(state, value) {
    state.sortParams = getSortAttributes(state, value.data, value.unit);
  },
  setValue(state, data) {
    // make sure values are correctly mapped for searchCriteria
    // !TODO move into seperate mutation
    const value = data.key === 'searchCriteria' ? typeMapper.mappingFunction(data.value) : data.value;
    state[data.key] = value;
  },
  setValues(state, data) {
    data.forEach((prop) => {
      // make sure values are correctly mapped for searchCriteria
      // !TODO move into seperate mutation
      const value = prop.key === 'searchCriteria' ? typeMapper.mappingFunction(prop.value) : prop.value;
      state[prop.key] = value;
    });
  },
  updateEnabledFilters(state, data) {
    const updated = (Array.isArray(data)) ? data : [data];
    state.enabledFilters = [...state.enabledFilters, ...updated];
  },
};
